// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_task_provenance.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AdoptCustomerFollowUpRequest, AdoptCustomerFollowUpResponse, ListCaptureTaskProvenanceRequest, ListCaptureTaskProvenanceResponse, ListCustomerFollowUpsRequest, ListCustomerFollowUpsResponse, SetCaptureTaskProvenanceRequest, SetCaptureTaskProvenanceResponse } from "./capture_task_provenance_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * CaptureTaskProvenanceService is the browser-facing area / origin / assignment
 * stamp of a capture task (SAD-486), implemented by zou over pangaea's
 * CaptureTaskProvenanceGatewayService.
 *
 * The tenant and caller come ONLY from the gateway principal. Authorization is
 * the capture_project growth resolver seam (reads = "read", writes = "update"),
 * the same authority as UpsertCaptureTask; a pursuit outside the caller's
 * tenant is NotFound. Setting provenance never grants anyone access to the
 * pursuit or its sources.
 *
 * @generated from service mono.projectdata.v1.CaptureTaskProvenanceService
 */ export const CaptureTaskProvenanceService = {
    typeName: "mono.projectdata.v1.CaptureTaskProvenanceService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTaskProvenanceService.AdoptCustomerFollowUp
     */ adoptCustomerFollowUp: {
            name: "AdoptCustomerFollowUp",
            I: AdoptCustomerFollowUpRequest,
            O: AdoptCustomerFollowUpResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTaskProvenanceService.ListCustomerFollowUps
     */ listCustomerFollowUps: {
            name: "ListCustomerFollowUps",
            I: ListCustomerFollowUpsRequest,
            O: ListCustomerFollowUpsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTaskProvenanceService.ListCaptureTaskProvenance
     */ listCaptureTaskProvenance: {
            name: "ListCaptureTaskProvenance",
            I: ListCaptureTaskProvenanceRequest,
            O: ListCaptureTaskProvenanceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureTaskProvenanceService.SetCaptureTaskProvenance
     */ setCaptureTaskProvenance: {
            name: "SetCaptureTaskProvenance",
            I: SetCaptureTaskProvenanceRequest,
            O: SetCaptureTaskProvenanceResponse,
            kind: MethodKind.Unary
        }
    }
};
